import { render, staticRenderFns } from "./DashboardDefault.vue?vue&type=template&id=04f0049f&scoped=true&"
import script from "./DashboardDefault.vue?vue&type=script&lang=js&"
export * from "./DashboardDefault.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDefault.vue?vue&type=style&index=0&id=04f0049f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f0049f",
  null
  
)

export default component.exports